// import React, { useState, useRef ,useEffect } from "react";
// import "./LevelReview.css";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// const LevelReview = () => {
//   // const [levels, setLevels] = useState([
//   //   { id: 1, name: "Approve", showPlus: true },
//   // ]);

//   const addNextLevel = () => {
//     const nextLevelNumber = levels.length + 1;
//     if (nextLevelNumber <= 4) {
//       setLevels((prevLevels) => [
//         ...prevLevels.map((level) => ({ ...level, showPlus: false })),
//         {
//           id: nextLevelNumber,
//           name: `LEVEL ${nextLevelNumber}`,
//           showPlus: true,
//         },
//       ]);
//     }
//   };

//   // const renderConnectorLines = () => {
//   //   const levelCount = levels.length;
//   //   return (
//   //     <div className="connector-lines">
//   //       {levelCount >= 2 && <div className="line-upload-to-level2" />}
//   //       {levelCount === 2 && <div className="line-level2-to-publish" />}
//   //       {levelCount === 3 && <div className="line-level3-to-publish" />}
//   //       {levelCount === 4 && <div className="line-level4-to-publish" />}
//   //     </div>
//   //   );
//   // };

//   const [levels, setLevels] = useState([
//     { id: 1, name: "Approve", showPlus: true },
//   ]);
//   const uploadRef = useRef(null);
//   const publishRef = useRef(null);
//   const levelRefs = useRef({});
//   const svgRef = useRef(null);

//   useEffect(() => {
//     drawConnectorLines();
//   }, [levels]);

//   const drawConnectorLines = () => {
//     if (!svgRef.current) return;

//     const svg = svgRef.current;
//     svg.innerHTML = "";

//     const uploadBox = uploadRef.current?.getBoundingClientRect();
//     const publishBox = publishRef.current?.getBoundingClientRect();
//     const svgBox = svg.getBoundingClientRect();

//     levels.forEach((level, index) => {
//       const levelBox = levelRefs.current[level.id]?.getBoundingClientRect();
//       if (!levelBox) return;

//       // Draw line from upload to first level
//       if (index === 0) {
//         createLine(
//           uploadBox.right - svgBox.left,
//           uploadBox.top - svgBox.top + uploadBox.height / 2,
//           levelBox.left - svgBox.left,
//           levelBox.top - svgBox.top + levelBox.height / 2
//         );
//       }

//       // Draw line from last level to publish
//       if (index === levels.length - 1) {
//         createLine(
//           levelBox.right - svgBox.left,
//           levelBox.top - svgBox.top + levelBox.height / 2,
//           publishBox.left - svgBox.left,
//           publishBox.top - svgBox.top + publishBox.height / 2
//         );
//       }
//     });
//   };

//   const createLine = (x1, y1, x2, y2) => {
//     const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
//     line.setAttribute("x1", x1);
//     line.setAttribute("y1", y1);
//     line.setAttribute("x2", x2);
//     line.setAttribute("y2", y2);
//     line.setAttribute("stroke", "black");
//     line.setAttribute("stroke-width", "2");
//     svgRef.current.appendChild(line);
//   };
//   return (
//     <>
//       <div className="Base-Container-for-all">
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>LEVEL SET</p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             height: "auto",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div className="row-cs">
//             <div className="col-cs "> Course</div>
//             <div className="col-cs"> Subject</div>
//             <div className="col-cs"> Chapter</div>
//           </div>
//           <div className="row-cs" style={{ position: "relative" }}>
//             <svg
//               ref={svgRef}
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 pointerEvents: "none",
//               }}
//             />
//             <div className="col-cs">
//               <p ref={uploadRef} className="border-dotted">
//                 Upload
//               </p>
//             </div>
//             <div className="col-cs">
//               {levels.map((level) => (
//                 <div
//                   key={level.id}
//                   ref={(el) => (levelRefs.current[level.id] = el)}
//                   className="level-container"
//                 >
//                   <p className="border-dotted">{level.name}</p>
//                   {level.showPlus && (
//                     <div className="plus-container">
//                       <img
//                         className="yg-LR"
//                         src={YellowPlus}
//                         onClick={addNextLevel}
//                         alt=""
//                       />
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//             <div className="col-cs">
//               <p ref={publishRef} className="border-dotted">
//                 Publish
//               </p>
//             </div>
//           </div>
//           {/* <div className="button-container">
//             <button className="simple-review-parser-btn">Apply to All</button>
//           </div> */}
//         </div>
//       </div>
//     </>
//   );
// };

// export default LevelReview;

// import React, { useState } from "react";
// import ReactFlow, { Handle, Edge, Background } from "react-flow-renderer";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";
// import "./LevelReview.css";

// const LevelReview = () => {
//   const [levels, setLevels] = useState([
//     { id: "1", name: "Approve", showPlus: true },
//   ]);
//   const [edges, setEdges] = useState([
//     { id: "e-upload-1", source: "upload", target: "1" },
//     { id: "e-1-publish", source: "1", target: "publish" },
//   ]);
//   const [nodes, setNodes] = useState([
//     {
//       id: "upload",
//       data: { label: "Upload" },
//       position: { x: 50, y: 100 },
//       style: { border: "1px dotted black", padding: 10 },
//     },
//     {
//       id: "1",
//       data: { label: "Approve" },
//       position: { x: 300, y: 100 },
//       style: { border: "1px dotted black", padding: 10 },
//     },
//     {
//       id: "publish",
//       data: { label: "Publish" },
//       position: { x: 600, y: 100 },
//       style: { border: "1px dotted black", padding: 10 },
//     },
//   ]);

//   const addNextLevel = () => {
//     const nextLevelNumber = levels.length + 1;
//     if (nextLevelNumber <= 4) {
//       const newLevelId = `${nextLevelNumber}`;
//       const prevLevelId = `${levels.length}`;

//       // Add the new level node
//       setNodes((prevNodes) => [
//         ...prevNodes,
//         {
//           id: newLevelId,
//           data: { label: `LEVEL ${nextLevelNumber}` },
//           position: { x: 300, y: 100 + 100 * levels.length },
//           style: { border: "1px dotted black", padding: 10 },
//         },
//       ]);

//       // Add the edge connecting the previous level to the new level
//       setEdges((prevEdges) => [
//         ...prevEdges.filter((edge) => edge.target !== "publish"),
//         { id: `e-${prevLevelId}-${newLevelId}`, source: prevLevelId, target: newLevelId },
//         { id: `e-${newLevelId}-publish`, source: newLevelId, target: "publish" },
//       ]);

//       // Update levels state
//       setLevels((prevLevels) => [
//         ...prevLevels.map((level) => ({ ...level, showPlus: false })),
//         { id: newLevelId, name: `LEVEL ${nextLevelNumber}`, showPlus: true },
//       ]);
//     }
//   };

//   return (
//     <div className="Base-Container-for-all">
//       <div
//         style={{
//           width: "82vw",
//           height: "30px",
//           fontWeight: "600",
//           backgroundColor: "#D6D6D6",
//           alignContent: "center",
//           paddingLeft: "8px",
//           boxShadow: "4px 4px 4px 0px #00000040",
//           border: "1px solid lightgrey",
//         }}
//       >
//         <p style={{ color: "#424342" }}>LEVEL SET</p>
//       </div>
//       <div
//         style={{
//           backgroundColor: "#FBFBFB",
//           height: "auto",
//           width: "82vw",
//           boxShadow: "4px 4px 4px 0px #00000040",
//           color: "#424342",
//           padding: "10px",
//           border: "1px solid lightgrey",
//         }}
//       >
//         <ReactFlow
//           nodes={nodes}
//           edges={edges}
//           fitView
//           elementsSelectable={false}
//           nodesDraggable={false}
//           edgesFocusable={false}
//           style={{ height: "1000px" }}
//         >
//           <Background />
//         </ReactFlow>
//         <div className="button-container">
//           {levels[levels.length - 1]?.showPlus && (
//             <img
//               className="yg-LR"
//               src={YellowPlus}
//               onClick={addNextLevel}
//               alt="Add Level"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LevelReview;

// import React, { useState } from "react";
// import ReactFlow, { Handle, Position } from "react-flow-renderer";
// import "./LevelReview.css";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";

// const LevelReview = () => {
//   const [levels, setLevels] = useState([
//     { id: "1", name: "Approve", showPlus: true },
//   ]);
//   const [edges, setEdges] = useState([
//     { id: "e-upload-1", source: "upload", target: "1" },
//     { id: "e-1-publish", source: "1", target: "publish" },
//   ]);
//   const [nodes, setNodes] = useState([
//     {
//       id: "upload",
//       data: { label: "Upload" },
//       position: { x: 50, y: 10 },
//       style: { width: 80, height: 30, border: "1px dotted black", padding: 5 , borderRadius: "10px" },
//       type: "upload",
//     },
//     {
//       id: "1",
//       data: { label: "Approve" },
//       position: { x: 300, y: 10 },
//       style: { width: 80, height: 30, border: "1px dotted black", padding: 5, borderRadius: "10px" },
//       type: "approve",
//     },
//     {
//       id: "publish",
//       data: { label: "Publish" },
//       position: { x: 600, y: 10 },
//       style: { width: 80, height: 30, border: "1px dotted black", padding: 5, borderRadius: "10px" },
//       type: "publish",
//     },
//   ]);

//   const addNextLevel = () => {
//     const nextLevelNumber = levels.length + 1;
//     if (nextLevelNumber <= 4) {
//       const newLevelId = `${nextLevelNumber}`;
//       const prevLevelId = `${levels.length}`;

//       setNodes((prevNodes) => [
//         ...prevNodes,
//         {
//           id: newLevelId,
//           data: { label: `LEVEL ${nextLevelNumber}` },
//           position: { x: 300, y: 10 + 50 * levels.length },
//           style: { width: 80, height: 30, border: "1px dotted black", padding: 5 , borderRadius: "10px"},
//           type: "level",
//         },
//       ]);

//       setEdges((prevEdges) => [
//         ...prevEdges.filter((edge) => edge.target !== "publish"),
//         { id: `e-${prevLevelId}-${newLevelId}`, source: prevLevelId, target: newLevelId },
//         { id: `e-${newLevelId}-publish`, source: newLevelId, target: "publish" },
//       ]);

//       setLevels((prevLevels) => [
//         ...prevLevels.map((level) => ({ ...level, showPlus: false })),
//         { id: newLevelId, name: `LEVEL ${nextLevelNumber}`, showPlus: true },
//       ]);
//     }
//   };

//   const nodeTypes = {
//     upload: ({ data }) => (
//       <div>
//         <Handle type="source" position={Position.Bottom} />
//         <div>{data.label}</div>
//       </div>
//     ),
//     publish: ({ data }) => (
//       <div>
//         <Handle type="target" position={Position.Left} />
//         <div>{data.label}</div>
//       </div>
//     ),
//     approve: ({ data }) => (
//       <div>
//         {/* <Handle type="source" position={Position.Right} /> */}
//         <Handle type="target" position={Position.Left} />
//         <Handle type="source" position={Position.Bottom} />
//         <div>{data.label}</div>
//       </div>
//     ),
//     level: ({ data }) => (
//       <div>
//         <Handle type="target" position={Position.Top} />
//         <Handle type="source" position={Position.Bottom} />
//         <div>{data.label}</div>
//       </div>
//     ),
//   };

//   const containerHeight = 100 + levels.length * 100;

//   return (
//     <div className="Base-Container-for-all">
//       <div
//         style={{
//           width: "82vw",
//           height: "30px",
//           fontWeight: "600",
//           backgroundColor: "#D6D6D6",
//           alignContent: "center",
//           paddingLeft: "8px",
//           boxShadow: "4px 4px 4px 0px #00000040",
//           border: "1px solid lightgrey",
//         }}
//       >
//         <p style={{ color: "#424342" }}>LEVEL SET</p>
//       </div>
//       <div
//         style={{
//           backgroundColor: "#FBFBFB",
//           height: "auto",
//           width: "82vw",
//           boxShadow: "4px 4px 4px 0px #00000040",
//           color: "#424342",
//           padding: "10px",
//           border: "1px solid lightgrey",
//         }}
//       >
//         <ReactFlow
//           nodes={nodes}
//           edges={edges}
//           nodeTypes={nodeTypes}
//           fitView
//           panOnScroll={false}
//           zoomOnScroll={false}
//           panOnDrag={false}
//           zoomOnPinch={false}
//           elementsSelectable={false}
//           nodesDraggable={false}
//           edgesFocusable={false}
//           style={{ height: `${containerHeight}px` }}
//         />
//         <div className="button-container">
//           {levels[levels.length - 1]?.showPlus && (
//             <img
//               className="yg-LR"
//               src={YellowPlus}
//               onClick={addNextLevel}
//               alt="Add Level"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LevelReview;

// import React, { useState, useRef, useEffect } from "react";
// import "./LevelReview.css";
// import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";

// const LevelReview = () => {
//   const [levels, setLevels] = useState([
//     { id: 1, name: "Approve", showPlus: true },
//   ]);
//   const uploadRef = useRef(null);
//   const publishRef = useRef(null);
//   const levelRefs = useRef({});
//   const svgRef = useRef(null);

//   useEffect(() => {
//     drawConnectorLines();
//   }, [levels]);

//   const drawConnectorLines = () => {
//     if (!svgRef.current) return;

//     const svg = svgRef.current;
//     svg.innerHTML = "";

//     const uploadBox = uploadRef.current?.getBoundingClientRect();
//     const publishBox = publishRef.current?.getBoundingClientRect();
//     const svgBox = svg.getBoundingClientRect();

//     const middleContainer = document
//       .querySelector(".border-dotted.middle-container")
//       ?.getBoundingClientRect();

//     levels.forEach((level, index) => {
//       const levelBox = levelRefs.current[level.id]?.getBoundingClientRect();
//       if (!levelBox) return;

//       if (index === 0) {
//         createLine(
//           uploadBox.right - svgBox.left,
//           uploadBox.top - svgBox.top + uploadBox.height ,
//           levelBox.left - svgBox.left,
//           levelBox.top - svgBox.top + levelBox.height
//         );
//       }
//     });

//     // Draw line from middle container to Publish
//     if (middleContainer) {
//       createLine(
//         middleContainer.right - svgBox.left,
//         middleContainer.top - svgBox.top + middleContainer.height / 5,
//         publishBox.left - svgBox.left,
//         publishBox.top - svgBox.top + publishBox.height / 5
//       );
//     }
//   };

//   const createLine = (x1, y1, x2, y2) => {
//     const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
//     line.setAttribute("x1", x1);
//     line.setAttribute("y1", y1);
//     line.setAttribute("x2", x2);
//     line.setAttribute("y2", y2);
//     line.setAttribute("stroke", "black");
//     line.setAttribute("stroke-width", "2");
//     svgRef.current.appendChild(line);
//   };

//   const addNextLevel = () => {
//     const nextLevelNumber = levels.length + 1;
//     if (nextLevelNumber <= 4) {
//       setLevels((prevLevels) => [
//         ...prevLevels.map((level) => ({ ...level, showPlus: false })),
//         {
//           id: nextLevelNumber,
//           name: `LEVEL ${nextLevelNumber}`,
//           showPlus: true,
//         },
//       ]);
//     }
//   };

//   return (
//     <>
//       <div className="Base-Container-for-all">
//         <div
//           style={{
//             width: "82vw",
//             height: "30px",
//             fontWeight: "600",
//             backgroundColor: "#D6D6D6",
//             alignContent: "center",
//             paddingLeft: "8px",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <p style={{ color: "#424342" }}>LEVEL SET</p>
//         </div>
//         <div
//           style={{
//             backgroundColor: "#FBFBFB",
//             height: "auto",
//             width: "82vw",
//             boxShadow: "4px 4px 4px 0px #00000040",
//             color: "#424342",
//             padding: "10px",
//             border: "1px solid lightgrey",
//           }}
//         >
//           <div className="row-cs">
//             <div className="col-cs "> Course</div>
//             <div className="col-cs"> Subject</div>
//             <div className="col-cs"> Chapter</div>
//           </div>
//           <div className="row-cs" style={{ position: "relative" }}>
//             <svg
//               ref={svgRef}
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 pointerEvents: "none",
//               }}
//             />
//             <div className="col-cs">
//               <p ref={uploadRef} className="border-dotted">
//                 Upload
//               </p>
//             </div>
//             <div className="col-cs">
//               <div className="border-dotted middle-container" >
//                 {levels.map((level) => (
//                   <div
//                     key={level.id}
//                     ref={(el) => (levelRefs.current[level.id] = el)}
//                     className="level-container"
//                   >
//                     <p className="border-dotted">{level.name}</p>
//                     {level.showPlus && (
//                       <div className="plus-container">
//                         <img
//                           className="yg-LR"
//                           src={YellowPlus}
//                           onClick={addNextLevel}
//                           alt=""
//                         />
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div className="col-cs">
//               <p ref={publishRef} className="border-dotted">
//                 Publish
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LevelReview;

import React, { useState } from "react";
import ReactFlow, { Handle, Position } from "react-flow-renderer";
import "./LevelReview.css";
import YellowPlus from "../../../Assets/Images/CommanImages/YellowPlus.png";

const LevelReview = () => {
  const [editingNode, setEditingNode] = useState(null);
  const [descriptions, setDescriptions] = useState({});
  const [levels, setLevels] = useState([
    { id: "1", name: "Approve", showPlus: true },
  ]);
  const [edges, setEdges] = useState([
    { id: "e-upload-1", source: "upload", target: "1" },
    { id: "e-1-publish", source: "1", target: "publish" },
  ]);
  const [nodes, setNodes] = useState([
    {
      id: "upload",
      data: { label: "Upload" },
      position: { x: 50, y: 10 },
      style: {
        width: 80,
        height: 30,
        border: "1px dotted black",
        padding: 5,
        borderRadius: "10px",
      },
      type: "upload",
    },
    {
      id: "1",
      data: { label: "Approve" },
      position: { x: 300, y: 10 },
      style: {
        width: 80,
        height: 30,
        border: "1px dotted black",
        padding: 5,
        borderRadius: "10px",
      },
      type: "approve",
    },
    {
      id: "publish",
      data: { label: "Publish" },
      position: { x: 600, y: 10 },
      style: {
        width: 80,
        height: 30,
        border: "1px dotted black",
        padding: 5,
        borderRadius: "10px",
      },
      type: "publish",
    },
  ]);

  const addNextLevel = () => {
    const nextLevelNumber = levels.length + 1;
    if (nextLevelNumber <= 4) {
      const newLevelId = `${nextLevelNumber}`;
      const prevLevelId = `${levels.length}`;

      setNodes((prevNodes) => [
        ...prevNodes,
        {
          id: newLevelId,
          data: { label: `LEVEL ${nextLevelNumber}` },
          position: { x: 300, y: 10 + 50 * levels.length },
          style: {
            width: 80,
            height: 30,
            border: "1px dotted black",
            padding: 5,
            borderRadius: "10px",
          },
          type: "level",
        },
      ]);

      setEdges((prevEdges) => [
        ...prevEdges.filter((edge) => edge.target !== "publish"),
        {
          id: `e-${prevLevelId}-${newLevelId}`,
          source: prevLevelId,
          target: newLevelId,
        },
        {
          id: `e-${newLevelId}-publish`,
          source: newLevelId,
          target: "publish",
        },
      ]);

      setLevels((prevLevels) => [
        ...prevLevels.map((level) => ({ ...level, showPlus: false })),
        { id: newLevelId, name: `LEVEL ${nextLevelNumber}`, showPlus: true },
      ]);
    }
  };

  const addDescriptionBubble = (event, node) => {
    const newNodeId = `desc-${Date.now()}`;
    const newNode = {
      id: newNodeId,
      data: { label: "Write a description here", description: "" },
      position: { x: node.position.x + 200, y: node.position.y },
      type: "description",
    };

    const newEdge = {
      id: `e-${node.id}-${newNodeId}`,
      source: node.id,
      target: newNodeId,
      type: "smoothstep",
    };

    setNodes((prevNodes) => [...prevNodes, newNode]);
    setEdges((prevEdges) => [...prevEdges, newEdge]);
  };

  const nodeTypes = {
    upload: ({ data }) => (
      <div>
        <Handle type="source" position={Position.Bottom} />
        <div>{data.label}</div>
      </div>
    ),
    publish: ({ data }) => (
      <div>
        <Handle type="target" position={Position.Left} />
        <div>{data.label}</div>
      </div>
    ),
    approve: ({ data, id }) => (
      <div>
        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Bottom} />
        <div>{data.label}</div>
      </div>
    ),
    level: ({ data, id }) => (
      <div>
        <Handle type="target" position={Position.Top} />
        <Handle type="source" position={Position.Bottom} />
        <div>{data.label}</div>
      </div>
    ),
    description: ({ data }) => (
      <div
        style={{
          // padding: "10px",
          // border: "1px solid black",
          // borderRadius: "5px",
          style:"none",
        }}
      >
        <textarea
          autoFocus
          defaultValue={data.description || ""}
          onBlur={(e) => {
            data.description = e.target.value;
          }}
          style={{
            width: "50px",
            height: "20px",
            border: "1px dotted black",
            borderRadius: "10px",
          }}
        />
      </div>
    ),
  };

  const containerHeight = 100 + levels.length * 100;

  return (
    <div className="Base-Container-for-all">
      <div
        style={{
          width: "82vw",
          height: "30px",
          fontWeight: "600",
          backgroundColor: "#D6D6D6",
          alignContent: "center",
          paddingLeft: "8px",
          boxShadow: "4px 4px 4px 0px #00000040",
          border: "1px solid lightgrey",
        }}
      >
        <p style={{ color: "#424342" }}>LEVEL SET</p>
      </div>
      <div
        style={{
          backgroundColor: "#FBFBFB",
          height: "auto",
          width: "82vw",
          boxShadow: "4px 4px 4px 0px #00000040",
          color: "#424342",
          padding: "10px",
          border: "1px solid lightgrey",
        }}
      >
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          fitView
          panOnScroll={false}
          zoomOnScroll={false}
          panOnDrag={false}
          zoomOnPinch={false}
          elementsSelectable={true} // Allow selection for nodes
          nodesDraggable={true} // Allow nodes to be dragged
          edgesFocusable={true} // Allow edges to be focused
          onNodeDoubleClick={addDescriptionBubble} // Correctly bound event
          style={{ height: `${containerHeight}px` }} // Ensure correct height
        />

        <div className="button-container">
          {levels[levels.length - 1]?.showPlus && (
            <img
              className="yg-LR"
              src={YellowPlus}
              onClick={addNextLevel}
              alt="Add Level"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LevelReview;
